<template>
  <div class="o-wrapper">
    <div class="c-pulldownMenu">
      <select class="c-pulldownMenu_selectbox" @change="onChange">
        <option
          v-for="(orderType, index) in orderTypes"
          :key="`sort_type_${index}`"
          :selected="orderType === currentOrderType"
          :value="orderType"
        >{{ orderType }}</option>
      </select>
      <span class="c-pulldownMenu_trigger"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderTypes: Array,
    currentOrderType: String
  },
  methods: {
    onChange (e) {
      const orderType = e.target.value
      this.$emit('selectOrderType', orderType)
    }
  }
}
</script>

<style lang="scss">
// styled by external css
</style>
